export default __webpack_public_path__ + "static/media/Guest-documentation.fc641795.md";